__turbopack_context__.v({
  "slideIn": "Toast-module__6DxLqW__slideIn",
  "styledToast": "Toast-module__6DxLqW__styledToast",
  "toastClose": "Toast-module__6DxLqW__toastClose",
  "toastContainer": "Toast-module__6DxLqW__toastContainer",
  "toastContent": "Toast-module__6DxLqW__toastContent",
  "toastMessage": "Toast-module__6DxLqW__toastMessage",
});
